import {
  EDUCATION_SERVICE_KIND_GET_REQUEST,
  EDUCATION_SERVICE_KIND_GET_SUCCESS,
  EDUCATION_SERVICE_KIND_GET_ERROR,
  EDUCATION_SERVICE_KIND_GET_BY_KEY_REQUEST,
  EDUCATION_SERVICE_KIND_GET_BY_KEY_SUCCESS,
  EDUCATION_SERVICE_KIND_GET_BY_KEY_ERROR,
  EDUCATION_SERVICE_KIND_ADD_REQUEST,
  EDUCATION_SERVICE_KIND_ADD_SUCCESS,
  EDUCATION_SERVICE_KIND_ADD_ERROR,
  EDUCATION_SERVICE_KIND_EDIT_REQUEST,
  EDUCATION_SERVICE_KIND_EDIT_SUCCESS,
  EDUCATION_SERVICE_KIND_EDIT_ERROR,
  EDUCATION_SERVICE_KIND_DELETE_REQUEST,
  EDUCATION_SERVICE_KIND_DELETE_SUCCESS,
  EDUCATION_SERVICE_KIND_DELETE_ERROR,
} from "../constants/educationServiceKindConstants";

const initialState = {
  educationServiceKinds: [],
  educationServiceKind: {},
  loading: false,
  success: null,
  error: null,
  educationServiceKindRequestedCount: 0,
};

export const educationServiceKindReducer = (state = initialState, action) => {
  switch (action.type) {
    case EDUCATION_SERVICE_KIND_GET_REQUEST:
      return {
        ...state,
        loading: true,
        educationServiceKindRequestedCount: ++state.educationServiceKindRequestedCount,
      };
    case EDUCATION_SERVICE_KIND_GET_SUCCESS:
      return {
        ...state,
        loading: false,
        educationServiceKinds: action.payload,
        success: true,
      };
    case EDUCATION_SERVICE_KIND_GET_ERROR:
      return {
        ...state,
        loading: false,
        success: false,
        error: action.payload,
      };
    case EDUCATION_SERVICE_KIND_GET_BY_KEY_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case EDUCATION_SERVICE_KIND_GET_BY_KEY_SUCCESS:
      return {
        ...state,
        loading: false,
        educationServiceKind: action.payload,
        success: true,
      };
    case EDUCATION_SERVICE_KIND_GET_BY_KEY_ERROR:
      return {
        ...state,
        loading: false,
        success: false,
        error: action.payload,
      };
    case EDUCATION_SERVICE_KIND_ADD_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case EDUCATION_SERVICE_KIND_ADD_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
      };
    case EDUCATION_SERVICE_KIND_ADD_ERROR:
      return {
        ...state,
        loading: false,
        success: false,
        error: action.payload,
      };
    case EDUCATION_SERVICE_KIND_EDIT_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case EDUCATION_SERVICE_KIND_EDIT_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
      };
    case EDUCATION_SERVICE_KIND_EDIT_ERROR:
      return {
        ...state,
        loading: false,
        success: false,
        error: action.payload,
      };
    case EDUCATION_SERVICE_KIND_DELETE_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case EDUCATION_SERVICE_KIND_DELETE_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
      };
    case EDUCATION_SERVICE_KIND_DELETE_ERROR:
      return {
        ...state,
        loading: false,
        success: false,
        error: action.payload,
      };
    default:
      return state;
  }
};
